import { ProductTypeUpsellingAssortment } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchUpsellingProductTypes = (productTypeId: string) =>
  fetchFromDesignerService<ProductTypeUpsellingAssortment[]>(
    `assortment/${productTypeId}/upselling`,
    { shopId: getParams().contextId }
  );
